/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST /api/jobs/{job_id}/sequences/{id}/steps/reorder``.
 */
export interface StepReorderRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  step_ids: string[];
}
